import { zfUtils } from "./zf_utils";
import { Swiper, Pagination, A11y } from "./swiper-config";
export class zfcct {
    static calcFontSize(num, item) {
        var fontSize = 0, cUnit = 0, secondUnit = 0, totalNumLen = 0;
        $(item).find(".zfcct-custom-unit").length > 0
            ? (cUnit = $(item).find(".zfcct-custom-unit").text().length)
            : (cUnit = 0);
        $(item).find(".zfcct-secondary-unit").length > 0
            ? (secondUnit = $(item).find(".zfcct-secondary-unit").text().length)
            : (secondUnit = 0);
        totalNumLen = num.toString().length + cUnit + secondUnit;
        if ($(window).outerWidth() > 720) {
            if ($(item).hasClass("zfcct-item-small")) {
                if ($(window).outerWidth() <= 1024 && $(window).outerWidth() > 950) {
                    fontSize = zfcct.scalableFontSize(zfcct.smallTileFontSize, 10, totalNumLen, 4, 9);
                    if (totalNumLen > 12) {
                        fontSize = fontSize + 5;
                    }
                }
                else if ($(window).outerWidth() <= 950) {
                    fontSize = zfcct.scalableFontSize(zfcct.smallTileFontSize, 20, totalNumLen, 4, 9);
                    if (totalNumLen > 12) {
                        fontSize = fontSize + 6;
                    }
                }
                else {
                    fontSize = zfcct.scalableFontSize(zfcct.smallTileFontSize, 0, totalNumLen, 3, 8);
                }
            }
            else {
                if ($(item).hasClass("zfcct-item-medium")) {
                    if ($(window).outerWidth() <= 1024 && $(window).outerWidth() > 950) {
                        fontSize = zfcct.scalableFontSize(zfcct.baseTileFontSize, 22, totalNumLen, 3, 8);
                    }
                    else if ($(window).outerWidth() <= 950) {
                        fontSize = zfcct.scalableFontSize(zfcct.baseTileFontSize, 30, totalNumLen, 3, 8);
                    }
                    else {
                        fontSize = zfcct.scalableFontSize(zfcct.baseTileFontSize, 12, totalNumLen, 3, 8);
                    }
                }
                else {
                    if ($(window).outerWidth() <= 1024 && $(window).outerWidth() > 950) {
                        fontSize = zfcct.scalableFontSize(zfcct.baseTileFontSize, 0, totalNumLen, 4, 9);
                    }
                    else if ($(window).outerWidth() <= 950) {
                        fontSize = zfcct.scalableFontSize(zfcct.baseTileFontSize, 14, totalNumLen, 4, 9);
                    }
                    else {
                        fontSize = zfcct.scalableFontSize(zfcct.baseTileFontSize, 0, totalNumLen, 3, 8);
                    }
                }
            }
        }
        else {
            fontSize = zfcct.scalableFontSize(zfcct.baseTileFontSize, 5, totalNumLen, 3, 8);
        }
        $(item).hasClass("zfcct-font-calculated")
            ? null
            : $(item).addClass("zfcct-font-calculated");
        return fontSize;
    }
    static scalableFontSize(baseSize, baseSizeAdj, totalNumLen, x, scale) {
        return baseSize - baseSizeAdj - Math.floor(totalNumLen / x) * scale;
    }
    static numberFormat(num, decimals, thousands_sep, dec_point) {
        var parts = num.toFixed(decimals).split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_sep);
        return parts.join(dec_point);
    }
    static decimalPlaces(num, dec_point) {
        return num.indexOf(dec_point) == -1
            ? 0
            : num.length - num.indexOf(dec_point) - 1;
    }
    static initTiles(tiles) {
        if (tiles.hasClass("zfcct-swiper")) {
            if (!tiles.find(".zfcct-mobile-item-wrapper").hasClass("swiper-initialized")) {
                const swiper = new Swiper("#" + tiles.find(".zfcct-mobile-item-wrapper").attr("id"), {
                    modules: [Pagination, A11y],
                    slidesPerView: 1,
                    spaceBetween: 40,
                    centeredSlides: false,
                    loop: true,
                    normalizeSlideIndex: true,
                    preventClicks: false,
                    preventClicksPropagation: false,
                    pagination: {
                        enabled: true,
                        el: ".swiper-pagination",
                        type: "bullets",
                        clickable: true,
                        renderBullet: function (index, className) {
                            return ('<button type="button" class="' +
                                className +
                                '" aria-label="Go to slide ' +
                                (index + 1) +
                                '"></button>');
                        },
                    },
                    a11y: {
                        enabled: true,
                        nextSlideMessage: "Next slide",
                        prevSlideMessage: "Previous slide",
                        paginationBulletMessage: "Jump to slide {{index}}",
                        slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                        slideRole: "group",
                        itemRoleDescriptionMessage: "slide",
                    },
                });
            }
        }
        else {
            tiles.find(".zfcct-mobile-item-wrapper").not(".slick-initialized").slick({
                rows: 0,
                dots: true,
                dotsClass: "not-default custom-dots",
                swipeToSlide: true,
                slidesToShow: 1,
                infinite: true,
                arrows: false,
            });
        }
        tiles
            .find(".zfcct-item")
            .not(".zfcct-counter-complete")
            .not(".zfcct-font-calculated")
            .each(function (index, item) {
            var counter = $(item).find(".zfcct-item-counter-number"), counterContainer = counter.parent(), numberVal = counter.text(), currentNumber, fontSize, seperatorType = counter.data("separator"), decimalType = counter.data("decimal"), languageType = counter.data("lang"), numDecimals = zfcct.decimalPlaces(numberVal, decimalType);
            numberVal = parseFloat(languageType == "DE"
                ? numberVal.replace(RegExp(decimalType, "g"), ".")
                : numberVal).toFixed(numDecimals);
            counter.text(1);
            if ($(item).hasClass("zfcct-static-counter") == false ||
                ($(item).hasClass("zfcct-static-counter") == true &&
                    $(window).outerWidth() <= 720)) {
                if (languageType == "DE") {
                    fontSize = zfcct.calcFontSize(Math.round(parseFloat(parseFloat(numberVal.replace(RegExp(/\./, "g"), "")).toFixed(numDecimals))), item);
                }
                else {
                    fontSize = zfcct.calcFontSize(Math.round(parseFloat(parseFloat(numberVal.replace(RegExp(seperatorType, "g"), "")).toFixed(numDecimals))), item);
                }
                counterContainer.css({
                    fontSize: fontSize,
                });
            }
            counter.init = function () {
                counter.prop("counter", 0).animate({
                    counter: numberVal,
                }, {
                    duration: zfcct.duration,
                    step: function (now) {
                        currentNumber = zfcct.numberFormat(now, numDecimals, seperatorType, decimalType);
                        counter.text(currentNumber);
                    },
                });
            };
            if (zfUtils.inViewport(counter)) {
                counter.init();
                $(item).addClass("zfcct-counter-complete");
            }
            var prevScrollKey = $(item).data("zfcct-scroll-key");
            if (prevScrollKey !== undefined && prevScrollKey !== null) {
                zfUtils.offScroll(parseInt(prevScrollKey, 10));
            }
            var scrollKey = zfUtils.onScroll(function () {
                if (zfUtils.inViewport(counter)) {
                    if ($(item).hasClass("zfcct-counter-complete") == false) {
                        counter.init();
                        $(item).addClass("zfcct-counter-complete");
                    }
                }
            });
            if (scrollKey !== null) {
                $(item).data("zfcct-scroll-key", scrollKey);
            }
        });
    }
    static init() {
        $(".zfcct-counter-tiles").each(function () {
            zfUtils.loadOnScroll($(this), "delayZFCCTLoad", zfcct.initTiles);
        });
    }
}
zfcct.baseTileFontSize = 80;
zfcct.smallTileFontSize = 60;
zfcct.tabletFontSizeAdjustment = 22;
zfcct.duration = 2000;
zfcct.prevViewport = "";
try {
    zfUtils.onReady(zfcct.init);
}
catch (err) {
    console.log("initalization failed: zfcct.init() " + err.message);
}
